import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Input, Modal, Select, SelectOption } from 'components/ui';
import { EMAIL_TYPE_OPTIONS, MIN_INPUT_LENGTH } from 'constants/common';
import _ from 'lodash';
import { doesUserHavePermission, PERMISSIONS } from 'constants/auth';
import PermissionGuard from 'components/miscellaneous/PermissionGuard';

class CreateApiKey extends Component {
  state = {
    name: '',
    error: '',
    template_types: [],
    can_unsubscribe: false,
  };

  handleInputChange = event => {
    const { value } = event.target;
    this.setState({ name: value, error: '' });
  };

  setError = () => {
    const { name } = this.state;
    let error = '';
    if (!name) error = 'Required';
    else if (name.length < MIN_INPUT_LENGTH) {
      error = `Should have at least ${MIN_INPUT_LENGTH} characters`;
    }
    this.setState({ error });
  };

  validateValues = () => {
    const { name } = this.state;
    if (!name || name.length < MIN_INPUT_LENGTH) {
      this.setError();
      return false;
    }
    return true;
  };

  handleCreateKey = () => {
    const { onCreateApiKey, projectId } = this.props;
    const { name, template_types, can_unsubscribe } = this.state;
    if (this.validateValues()) {
      const payload = {
        name,
        projectId,
        can_unsubscribe,
        ...(template_types.length ? { template_types } : {}),
      };
      onCreateApiKey(payload);
      this.handleHide();
    }
  };

  handleHide = () => {
    this.props.onHide();
    this.reset();
  };

  handleSelectEmailTypeChange = selectedTemplateTypeIds => {
    this.setState({ template_types: selectedTemplateTypeIds });
  };

  reset = () => {
    this.setState({
      name: '',
      error: '',
    });
  };

  getPermittedOptions = options => {
    const { userPermissions } = this.props;
    if (
      doesUserHavePermission(PERMISSIONS.TRANSACTIONAL_MAIL, userPermissions)
    ) {
      return options;
    }
    return _.filter(options, o => o.id !== 2); // filter out the id for transactional type
  };

  renderEmailTypesSelectOptions = () => {
    const options = this.getPermittedOptions(EMAIL_TYPE_OPTIONS);
    return options.map(option => (
      <SelectOption key={option.name} value={option.id}>
        {_.capitalize(option.name)}
      </SelectOption>
    ));
  };

  render() {
    const { error, name, template_types } = this.state;
    const { isVisible } = this.props;

    return (
      <Modal
        visible={isVisible}
        onCancel={this.handleHide}
        onOk={this.handleCreateKey}
      >
        <div className="create-api-key">
          <h1>Create new API key</h1>
          <br />
          <Input
            error={error}
            helperTxt={error}
            label="API Key Name"
            name="name"
            placeholder="Key name"
            value={name}
            onChange={this.handleInputChange}
          />
          <PermissionGuard requiredPermission={PERMISSIONS.TRANSACTIONAL_MAIL}>
            <React.Fragment>
              <br />
              <Select
                allowClear
                mode="multiple"
                placeholder="Select Email Types"
                style={{ width: '100%' }}
                value={template_types}
                onChange={this.handleSelectEmailTypeChange}
              >
                {this.renderEmailTypesSelectOptions()}
              </Select>
            </React.Fragment>
          </PermissionGuard>

          <br />
          <br />
          <Checkbox
            checked={this.state.can_unsubscribe}
            onChange={e => this.setState({ can_unsubscribe: e.target.checked })}
          >
            Allow to be used to unsubscribe
          </Checkbox>
        </div>
      </Modal>
    );
  }
}

CreateApiKey.defaultProps = {
  userPermissions: [],
};

CreateApiKey.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  userPermissions: PropTypes.array,
  onCreateApiKey: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default CreateApiKey;
